if (!customElements.get('pc-complements')) {
  customElements.define('pc-complements', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.pool = [...this.querySelectorAll('template[data-complements-item]')];
      this.grid = this.querySelector('[data-complements-grid]');
      this.previous = new Set();
      this.renderSelection();
      this.querySelector('[data-complements-refresh]').addEventListener('click', () => {
        this.renderSelection();
        this.querySelector('[data-complements-status]').textContent = this.querySelector('[data-complements-announcement]').textContent;
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    renderSelection() {
      const shuffled = [...this.pool];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      shuffled.sort((a, b) => Number(this.previous.has(a.dataset.productId)) - Number(this.previous.has(b.dataset.productId)));
      const selected = [], families = new Set();
      for (const item of shuffled) {
        if (item.dataset.family === this.dataset.currentFamily || families.has(item.dataset.family)) continue;
        selected.push(item);
        families.add(item.dataset.family);
        if (selected.length === 4) break;
      }
      if (selected.length < 3) {
        for (const item of shuffled) {
          if (item.dataset.family === this.dataset.currentFamily || selected.includes(item)) continue;
          selected.push(item);
          if (selected.length === 4) break;
        }
      }
      this.hidden = selected.length < 3;
      if (this.hidden) return;
      this.previous = new Set(selected.map(item => item.dataset.productId));
      this.grid.replaceChildren(...selected.map(item => item.content.cloneNode(true)));
      this.dataset.count = String(selected.length);
      this.querySelector('[data-complements-refresh]').hidden = this.pool.length <= selected.length;
    }
  });
}
